import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setShowAnnouncementsModalReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showAnnouncementsModal = action.payload;
  });
};

export default setShowAnnouncementsModalReducer;
